import { Box, Grid, GridItem } from "@chakra-ui/react"
import { UI } from "components"

export default function Layout({ children }){
    return(
    <Grid templateColumns={{ base: '100%', sm: '100%', md: '100%', lg: '20% 78%' }} gap={2}>
        <GridItem hideBelow="lg">
            <UI.Nav />
        </GridItem>
        <GridItem>
            <Box p={{ base: 4, sm: 6, md: 6, lg: 0 }} mb={10}>{ children }</Box>
        </GridItem>
    </Grid>
    )
}